module.exports = __webpack_public_path__ + "static/media/Bg.50a2f1ca.jpg";